import axios from "api/axios";

// App Backend
export const getAllPatients = async () => {
  const response = await axios.get("/api/patients/");
  return response.data;
};